module.exports = __webpack_public_path__ + "img/testimony-2.0d1ea49c.png";